import type { Component } from 'vue'
import IconArrowRight from './IconArrowRight.vue'
import IconClose from './IconClose.vue'
import IconDelete from './IconDelete.vue'
import IconGroups from './IconGroups.vue'
import IconInfo from './IconInfo.vue'
import IconWarning from './IconWarning.vue'

export type IconName =
  | 'arrowRight'
  | 'close'
  | 'delete'
  | 'groups'
  | 'info'
  | 'warning'

export const ICON_SET: Record<IconName, Component> = {
  arrowRight: IconArrowRight,
  close: IconClose,
  delete: IconDelete,
  groups: IconGroups,
  info: IconInfo,
  warning: IconWarning,
}
